export const categories = [
  {
    slug: 'yuepao-jiqiao',
    name: '约炮技巧',
    description: '从心态调整到实战经验，全面掌握约炮的核心技巧',
    icon: 'ri-lightbulb-flash-line',
    color: 'primary',
    articleCount: 6,
  },
  {
    slug: 'pingtai-tuijian',
    name: '平台推荐',
    description: '精选优质约炮平台与软件，帮你找到最适合的渠道',
    icon: 'ri-smartphone-line',
    color: 'accent',
    articleCount: 5,
  },
  {
    slug: 'liaotian-huashu',
    name: '聊天话术',
    description: '掌握高效沟通技巧，让每一次聊天都自然推进关系',
    icon: 'ri-chat-smile-2-line',
    color: 'secondary',
    articleCount: 5,
  },
  {
    slug: 'anquan-zhinan',
    name: '安全指南',
    description: '约会安全第一，了解注意事项保护自己与他人',
    icon: 'ri-shield-check-line',
    color: 'primary',
    articleCount: 4,
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    border: 'border-primary-200',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    border: 'border-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    border: 'border-secondary-200',
  },
};